import { useQuery } from '@tanstack/react-query';

import { type Endpoints } from '@/api';
import { useFetch } from '@/utils/fetch';

export const useBrandToWorkshops = (workshopId: string) => {
  const fetch = useFetch<Endpoints['GET /workshops/:workshopId/brand-to-workshops']>();

  return useQuery({
    queryKey: ['workshops', workshopId, 'brand-to-workshops'],
    queryFn: () => fetch(`/workshops/${workshopId}/brand-to-workshops`),
    enabled: !!workshopId,
  });
};
